module.exports = __webpack_public_path__ + "static/img/アセット 65@3x.165c77c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/アセット 65@3x.png
// module id = AbeX
// module chunks = 1